import { ApolloClient, HTTPBatchedNetworkInterface } from 'apollo-client';
import Session from '../../entity/session';

class GraphQLClient {
  private apollo: ApolloClient;
  private session: Session | null;
  private manageId: string;

  constructor({ url, batchInterval = 10, manageId }: { url: string; batchInterval?: number; manageId?: string; }) {
    const networkInterface = new HTTPBatchedNetworkInterface(url, batchInterval, {});
    this.manageId = manageId || this.manageId;

    networkInterface.use([
      {
        applyBatchMiddleware: (request, next) => {
          const session = this.session;

          if (session) {
            request.options.headers = {
              ...request.options.headers,
              ...{ authorization: `Bearer ${session.authenticationToken}` },
            };
          }

          request.options.headers = {
            ...request.options.headers,
            manageId: this.manageId,
          };

          next();
        },
      },
    ]);

    this.apollo = new ApolloClient({ networkInterface });
  }

  public query(session: Session | null, query: any, { variables }: { variables?: any } = {}) {
    this.session = session;

    return this.apollo.query({ query, variables, fetchPolicy: 'network-only' });
  }

  public mutate(session: Session | null, mutation: any, { variables }: { variables?: any } = {}) {
    this.session = session;

    return this.apollo.mutate({ mutation, variables });
  }
}

export default GraphQLClient;
